import { getTimeSuggestionsStore } from '../selectors/getTimeSuggestionsStore';

export default function getLastFindMeetingTimesRequestDate(viewStateId: string | null) {
    const store = getTimeSuggestionsStore(viewStateId);
    return store.lastFindMeetingTimesRequestDate;
}
